import React from 'react';

// Version constant - update this single value when releasing new versions
const EXTENSION_VERSION = "0.1.6";
const EXTENSION_NAME = "provider-extension";

const ExtensionPolicyArea = () => {
   return (
      <>
         <div className="service-details-area pt-120 pb-100" style={{backgroundColor:"#f4f9fc"}}>
            <div className="container">
               <div className="row">

                  <div className="col-xl-12 col-lg-12">
                     <article className="service-details-box">
                        <div className="section-title pos-rel mb-45">
                           <div className="section-icon">
                              <img className="section-back-icon back-icon-left" src="img/section/section-back-icon-sky.png" alt="" />
                           </div>
                           <div className="section-text pos-rel">
                              <h5 className="green-color text-up-case">Privacy Policy</h5>
                              <h2>Chrome Extension Privacy Policy</h2>
                           </div>
                           <div className="section-line pos-rel">
                              <img src="img/shape/section-title-line.png" alt="" />
                           </div>
                        </div>
                        <div className="service-details-text mb-30">
                           <h4>Overview</h4>
                           <p>This privacy policy describes how the Chrome extension "{EXTENSION_NAME}" (version {EXTENSION_VERSION}) collects, uses, and handles your information.</p>
                           
                           <h4>Information Collection and Use</h4>
                           <p>The {EXTENSION_NAME} is designed with privacy in mind. We are committed to the following privacy practices:</p>
                           <ul>
                              <li><strong>No Personal Data Collection</strong>: The extension does not collect, store, or transmit any personal information from users.</li>
                              <li><strong>No Browsing History</strong>: The extension does not track, access, or store your browsing history.</li>
                              <li><strong>No Cookies</strong>: The extension does not use cookies to track users.</li>
                           </ul>
                           
                           <h4>Data Storage</h4>
                           <p>Any data required for the extension's functionality is stored locally on your device and is not transmitted to external servers.</p>
                           
                           <h4>Third-Party Services</h4>
                           <p>The extension does not integrate with third-party analytics, tracking, or advertising services.</p>
                           
                           <h4>Changes to This Policy</h4>
                           <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the version number in the extension.</p>
                           
                           <h4>Contact</h4>
                           <p>If you have any questions about this Privacy Policy, please create an issue on our repository or contact the extension author.</p>
                        </div>
                     </article>
                  </div>
                  <hr/>
                  
                  <div className="col-xl-12 col-lg-12">
                     <article className="service-details-box">
                        <div className="section-title pos-rel mb-45">
                           <div className="section-icon">
                              <img className="section-back-icon back-icon-left" src="img/section/section-back-icon-sky.png" alt="" />
                           </div>
                           <div className="section-text pos-rel">
                              <h5 className="green-color text-up-case">Terms of Service</h5>
                              <h2>Chrome Extension Terms of Service</h2>
                           </div>
                           <div className="section-line pos-rel">
                              <img src="img/shape/section-title-line.png" alt="" />
                           </div>
                        </div>
                        <div className="service-details-text mb-30">
                           <h4>Overview</h4>
                           <p>This Terms of Service document governs your use of the Chrome extension "{EXTENSION_NAME}" (version {EXTENSION_VERSION}).</p>
                           
                           <h4>Acceptance of Terms</h4>
                           <p>By installing and using the {EXTENSION_NAME}, you agree to be bound by these Terms of Service. If you do not agree to these terms, please uninstall the extension immediately.</p>
                           
                           <h4>Use of the Extension</h4>
                           <p>The {EXTENSION_NAME} is provided "as is" and "as available" without warranties of any kind. We do not guarantee that the extension will function without interruption or errors.</p>
                           
                           <h4>Limitations of Liability</h4>
                           <p>In no event shall the developers of the {EXTENSION_NAME} be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of the extension.</p>
                           
                           <h4>Changes to These Terms</h4>
                           <p>We reserve the right to modify these Terms of Service at any time. We will notify users of any changes by updating the version number in the extension and posting the new Terms of Service on this page.</p>
                           
                           <h4>Contact</h4>
                           <p>If you have any questions about these Terms of Service, please create an issue on our repository or contact the extension author.</p>
                        </div>
                     </article>
                  </div>
                  <hr/>

                  <div className="col-xl-12 col-lg-12">
                     <article className="service-details-box">
                        <div className="section-title pos-rel mb-45">
                           <div className="section-icon">
                              {/* <img className="section-back-icon back-icon-left" src="img/section/section-back-icon-sky.png" alt="" /> */}
                           </div>
                           <div className="section-text pos-rel">
                              <h5 className="green-color text-up-case">Permissions</h5>
                              <h2>Extension Permissions</h2>
                           </div>
                           <div className="section-line pos-rel">
                              <img src="img/shape/section-title-line.png" alt="" />
                           </div>
                        </div>
                        <div className="service-details-text mb-30">
                           <p>Our extension requires minimal permissions to function properly. We only request access to the specific sites where the extension's functionality is needed. The extension does not request broad permissions to access all websites you visit.</p>
                           
                           <p>All extension operations happen locally within your browser. No data is sent to external servers unless explicitly initiated by you.</p>
                        </div>
                     </article>
                  </div>
                  <hr/>

                  <div className="col-xl-12 col-lg-12">
                     <article className="service-details-box">
                        <div className="section-title pos-rel mb-45">
                           <div className="section-icon">
                              {/* <img className="section-back-icon back-icon-left" src="img/section/section-back-icon-sky.png" alt="" /> */}
                           </div>
                           <div className="section-text pos-rel">
                              <h5 className="green-color text-up-case">Updates</h5>
                              <h2>Extension Update Policy</h2>
                           </div>
                           <div className="section-line pos-rel">
                              <img src="img/shape/section-title-line.png" alt="" />
                           </div>
                        </div>
                        <div className="service-details-text mb-30">
                           <p>We may release updates to improve functionality, fix bugs, or enhance security. Chrome will automatically update the extension when new versions are available. Each update undergoes review by the Chrome Web Store team before being released to users.</p>
                           
                           <p>For transparency, we maintain detailed release notes for each new version, which can be viewed on our repository.</p>
                           
                           <p><strong>Current Version:</strong> {EXTENSION_VERSION}</p>
                        </div>
                     </article>
                  </div>

               </div>
            </div>
         </div>
      </>
   );
};

export default ExtensionPolicyArea;